export default __webpack_public_path__ + "static/media/instagram.5178d252.svg";